export default "__VITE_ASSET__C5VjYoTj__"